import { render, staticRenderFns } from "./servizi-business.vue?vue&type=template&id=d7693d96&scoped=true&"
import script from "./servizi-business.vue?vue&type=script&lang=js&"
export * from "./servizi-business.vue?vue&type=script&lang=js&"
import style0 from "./servizi-business.vue?vue&type=style&index=0&id=d7693d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7693d96",
  null
  
)

export default component.exports